/**
 * Der CSS-Klassenname eines Formularfelds nach Sperr-/Erwartungszustand - Fundament fuer die
 * Feldzustand-Optik (Referenz `feldzustand-spec.md`, Klassen in
 * `styles/neubau/feldzustand.css`). Auftrag 0 legt nur diese Funktion und die Klassen an; welches
 * Feld welche Optionen bekommt, entscheiden die Folgeauftraege je Tab-Datei anhand der
 * Einstufungstabelle in der Spec.
 *
 * Prioritaet bei Kollision: `gesperrt` schlaegt `erwartet`+`leer` IMMER - ein gesperrtes Feld
 * bekommt nie zusaetzlich die amber-Optik, selbst wenn es zufaellig leer und eigentlich erwartet
 * waere.
 *
 * `leer` wird an der Aufrufstelle lokal aus dem aktuellen Feldwert berechnet (leerer String /
 * `null` / `undefined`; bei Zahlenfeldern NUR `null`/`undefined`, NICHT `0` - `0` ist ein
 * gueltiger gesetzter Wert, siehe das Preis-Feld in Positionen.tsx). Fuer Checkboxen gilt das
 * Leer-Konzept nicht - dort wird `erwartet` an der Aufrufstelle nie gesetzt.
 */
export function feldZustandClass(opts: { gesperrt?: boolean; erwartet?: boolean; leer?: boolean }): string {
  if (opts.gesperrt) return "feld-gesperrt";
  if (opts.erwartet && opts.leer) return "feld-erwartet-leer";
  return "";
}
